import React, { useEffect, useMemo } from 'react';
import { arrayOf, object, string, bool } from 'prop-types';
import classnames from 'classnames';
import Scroller from '../../shared/NotableClients/Scroller';
import { MP_VIEWED_NOTABLE_CLIENTS } from '../../../utils/mixPanelEvents';
import WithImpressions from '../../shared/withImpressions';
import { getDisplayedNotableClients } from '../../shared/NotableClients/helper';
import ClientList from '../../shared/NotableClients/ClientList';
import ClientLogo from '../../shared/NotableClients/ClientLogo';
import TopClientsTitle from '../../shared/NotableClients/TopClientsTitle';
import './style.scss';

const CLASS_NAME = 'notable-clients-bar';

const NotableClientsBar = ({
    notableClients,
    sellerName,
    profilePhoto,
    wrap = false,
    impressionRef,
    collectImpressions
}, { biEvents }) => {
    const displayClients = useMemo(() => getDisplayedNotableClients(notableClients), [notableClients]);
    const notableClientMixPanelParams = {
        'source component': 'Gig page',
        'seller Name' : sellerName,
        'has sbss' : !!wrap,
        'number of clients' : displayClients.length
    };
    const clientListProps = {
        logoSize: ClientLogo.SIZES.SMALL,
        displayClients,
        sellerName,
        profilePhoto,
        mixPanelParams: notableClientMixPanelParams,
        source: ClientList.SOURCES.ABOVE_THE_FOLD
    };

    useEffect(() => {
        collectImpressions();
        biEvents.sendMixPanelEvent({
            eventName: MP_VIEWED_NOTABLE_CLIENTS,
            params: {
                ...notableClientMixPanelParams,
                'clients name' : displayClients.map((client) => client.name)
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classnames(CLASS_NAME, { 'wrap-elements': wrap })} ref={impressionRef}>
            <TopClientsTitle sellerName={sellerName} educate isWrapped={wrap}/>
            <Scroller className="scroll-hider">
                <ClientList {...clientListProps}/>
            </Scroller>
        </div>
    );
};

NotableClientsBar.propTypes = {
    notableClients: arrayOf(object),
    sellerName: string,
    profilePhoto: string,
    wrap: bool
};

NotableClientsBar.contextTypes = {
    biEvents: object
};

const impressionConfig = {
    DOMSelector: `.${CLASS_NAME} > div`,
    eventKey: 'notable_client_above_the_fold_component_is_shown'
};

export { NotableClientsBar };
export default WithImpressions(NotableClientsBar, impressionConfig);
